"use client";
import _ from "lodash";
import { Fragment } from "react";
import styles from "./index.module.scss";

interface TitProps {
  title: string;
  cont?: any;
  tip?: string;
  imgUrl?: string;
  titleAdd?: string;
  imgClass?: string;
  descTit?: string;
  tipTocont?: boolean;
  tipOverbold?: boolean;
  desc?: string;
  textAlign?: any;
}

export default function TitleComp(titProps: TitProps) {
  const {
    title,
    cont,
    imgUrl,
    titleAdd,
    tip,
    imgClass,
    textAlign,
    descTit,
    desc,
    tipTocont,
    tipOverbold,
  } = titProps;
  return (
    <div className={styles.titleBox}>
      <div className={styles.cont + " mediaCont"}>
        <h6 className={styles.tit + " tit"}>
          {title}
          {titleAdd && <span>{titleAdd}</span>}
        </h6>
        {tip && (
          <div
            className={
              styles.txtTwo +
              " txtTwo " +
              `${tipTocont ? styles.useTxtSize : ""}` +
              `${tipOverbold ? styles.bold : ""}`
            }
          >
            {tip}
          </div>
        )}
        <div
          className={
            styles.txt + " txt " + `${tipTocont ? styles.useTxtTwoSize : ""}`
          }
          style={{ textAlign }}
        >
          {cont && _.isArray(cont)
            ? _.get(titProps, "cont", []).map((c: string) => {
                return (
                  <Fragment>
                    {c}
                    <br />
                  </Fragment>
                );
              })
            : cont}
        </div>
        {descTit && (
          <div className={styles.descTit + " descTit"}>{descTit}</div>
        )}
        {desc && <div className={styles.desc + " desc"}>{desc}</div>}
        {imgUrl && (
          <div className={styles.img + ` ${imgClass}`}>
            <img src={imgUrl} />
          </div>
        )}
      </div>
    </div>
  );
}
